import React from "react";

class HubSpotComponent extends React.Component {
  hubSpotScriptSrc =
    "https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js";

  componentDidMount() {
    const head = document.querySelector("head");
    const script = document.createElement("script");
    script.setAttribute("src", this.hubSpotScriptSrc);
    script.setAttribute("id", "hubSpotScript");
    head.appendChild(script);
  }

  componentWillUnmount() {
    const head = document.querySelector("head");
    const script = document.getElementById("hubSpotScript");
    if (script) {
      head.removeChild(script);
      console.log("script deleted", script);
    }
  }

  render() {
    return (
      <div id="schedule_form">
        <div
          className="meetings-iframe-container"
          data-src="https://meetings-eu1.hubspot.com/martin-velten?embed=true"
        />
      </div>
    );
  }
}

export default HubSpotComponent;
